import React from "react";
import i18n from "~/i18n";

export const INVEST_LEVEL = [
	{ label: "Pre Seed", value: "1" },
	{ label: "Seed", value: "2" },
	{ label: "Pre Series", value: "3" },
	{ label: "Series A", value: "4" },
	{ label: "Series B", value: "5" },
	{ label: "Series C", value: "6" },
	{ label: "Series D", value: "7" },
	{ label: "Series E", value: "8" },
	{ label: "M&A", value: "9" },
	{ label: "Pre IPO", value: "10" },
	{ label: "IPO", value: "11" },
];

export const INVEST_LIST = [
	{
		id: "148",
		investCompanyName: "선보엔젤파트너스",
		investCompanyNameEng: "Sunbo Angel Partners",
		investMail: "contact@sunboangel.kr",
	},
	{
		id: "517",
		investCompanyName: "넥스파트너스",
		investCompanyNameEng: "Nex partners",
		investMail: "manager@illunex.com",
	},
];

export const AREA_TYPE = {
	0: i18n.t("constant.ApplyFormConstant.domestic"),
	1: i18n.t("constant.ApplyFormConstant.overseas"),
};

export const IP_TYPE = {
	0: i18n.t("constant.ApplyFormConstant.application"),
	1: i18n.t("constant.ApplyFormConstant.registration"),
};

export const SUNBO_ANGEL_PARTNERS_FORM_DATA = [
	{
		key: "",
		type: "text",
		inputType: "Q&A",
		title: [
			{
				title: "질문 1. 선보엔젤파트너스 IR 지원방식",
				answer: "IR 지원방식은 선보엔젤파트너스 웹사이트의 APPLY를 통해 Gitbal 플랫폼에서 진행됩니다. 아래 항목을 입력 및 제출해 주세요.\n업로드 파일은 서류(ppt, word, pdf 등), 소개 영상 혹은 드라이브 링크 contact@sunboangel.kr 추가 부탁드립니다.",
			},
			{
				title: "질문 2. 지원 후 절차",
				answer: "서류 접수 확인 메일 및 심사 결과는 기입하신 대표자 이메일을 통해 공유 드릴 예정입니다.\n서류 심사를 통과하신 경우 선보엔젤파트너스 담당자가 개별적인 연락을 통해 미팅을 진행하게 됩니다.",
			},
			{
				title: "질문 3. 지원 분야",
				answer: "바이오, 신소재 및 대체에너시 등의 기술 특화 분야 혹은 기타 다양한 신성장 산업 관련 분야의 신청을 환영합니다.",
			},
			{
				title: "질문 4. 선정 기준",
				answer: "선보엔젤파트너스는 창의적이고 혁신적인 아이디어와 기술을 보유한 업력 3년 이내 스타트업 혹은 예비창업자의 지원을 희망합니다.",
			},
		],
		titleEng: [
			{
				title: "Q1. How To Apply For IR",
				answer: "IR application is available on the Gitbal platform via APPLY on the Sunbo Angel Partners website.\nPlease enter and submit the items below.\nPlease add a document (ppt, word, pdf and etc.) or an introductory video or drive link : contact@sunboangel.kr",
			},
			{
				title: "Q2. Next Step After Your Application",
				answer: "We will send the confirmation of your application and the results through the email of the representative.\nIf you pass the document screening, the person in charge of the Sunbo Angel Partners will contact you individually to proceed with the meeting.",
			},
			{
				title: "Q3. Application Field",
				answer: "We welcome applications from deep-technology areas such as bio, new materials and alternative energy sources, or a variety of other new growth industries.",
			},
			{
				title: "Q4. Selection Criteria",
				answer: "We are waiting for startups within three years of establishment or prospective entrepreneurs of having creative and innovative ideas and technologies.",
			},
		],
		required: false,
	},
	{
		key: "dividerFirst",
		inputType: "divider",
		title: "1. 기본정보 입력",
		titleEng: "1. Basic information",
		description: (
			<>
				신청 스타트업의 기본정보를 빠짐없이 알려주시면 적극적으로 검토해 보도록하겠습니다.
				<br />
			</>
		),
		descriptionEng: (
			<>
				Please tell us all the basic information of the application startup. <br />
				We will actively review it.
			</>
		),
	},
	{
		key: "applyCompany.companyName",
		type: "text",
		inputType: "text",
		title: "[1-1] 기업명",
		titleEng: "[1-1] Company Name",
		required: true,
	},
	{
		key: "applyCompany.companyOwner",
		type: "text",
		inputType: "text",
		title: "[1-2] 대표자 이름",
		titleEng: "[1-2] Representative Name",
		required: true,
	},
	{
		key: "applyCompany.contact",
		type: "text",
		inputType: "text",
		title: "[1-3] 대표자 연락처",
		titleEng: "[1-3] Representative Contact",
		required: true,
	},
	{
		key: "email",
		type: "text",
		inputType: "text",
		title: "[1-4] 대표자 이메일",
		titleEng: "[1-4] Representative Email",
		required: true,
	},
	{
		key: "applyCompany.establishmentDate",
		type: "date",
		inputType: "date",
		title: "[1-5] 설립연월",
		titleEng: "[1-5] Date of establishment",
		required: true,
	},
	{
		key: "applyCompany.employees",
		type: "number",
		inputType: "number",
		title: "[1-6] 직원 수",
		titleEng: "[1-6] Number of employees",
		required: true,
	},
	{
		key: "applyCompany.country",
		type: "select",
		inputType: "select",
		title: "[1-7] 국가",
		titleEng: "[1-7] Country",
		size: 1,
		required: true,
	},
	{
		key: "applyCompany.industryCategory",
		type: "checkbox",
		inputType: "checkbox",
		title: "[1-8] 산업분야",
		titleEng: "[1-8] Industrial Field",
		size: 1,
		required: true,
	},
	// {
	//     key: "applyCompany.keyword",
	//     type: "tags",
	//     inputType: "tags",
	//     title: "[1-9] 키워드",
	//     titleEng: "[1-9] Keyword",
	//     size: 1,
	//     required: true
	// },
	{
		key: "dividerSecond",
		inputType: "divider",
		title: "2. 투자정보",
		titleEng: "2. Investment Information",
		description: (
			<>
				신청 스타트업의 기본정보를 빠짐없이 알려주시면 적극적으로 검토해 보도록하겠습니다.
				<br />
			</>
		),
		descriptionEng: (
			<>
				Please tell us all the basic information of the application startup. <br />
				We will actively review it.
			</>
		),
	},
	{
		key: "applyCompany.investStep",
		type: "select",
		inputType: "select",
		size: 1,
		title: "[2-1] 투자단계",
		titleEng: "[2-1] Investment Stage",
		required: false,
	},
	{
		key: "dividerThird",
		inputType: "divider",
		title: "3. 제품/ 기술 / 시장",
		titleEng: "3. Product / Technology / Market",
		description: <>제안하는 제품/서비스에 대한 문제점, 해결방안에 대한 내용을 입력해주세요.</>,
		descriptionEng: (
			<>
				Please enter the contents of the problem and solution for the proposed
				product/service
			</>
		),
	},
	{
		key: "applyCompany.problem",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-1] 문제점",
		titleEng: "[3-1] Problems in the Existing Market",
		required: true,
	},
	{
		key: "applyCompany.solution",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-2] 해결방안",
		titleEng: "[3-2] Solution",
		required: true,
	},
	{
		key: "applyCompany.teamDescription",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-3] 팀 구성 및 소개",
		titleEng: "[3-3] Team Building and Introduction",
		required: true,
	},
	{
		key: "applyCompany.productKeyword",
		type: "tags",
		inputType: "tags",
		title: "[3-4] 제품 키워드",
		titleEng: "[3-4] Product Keyword",
		size: 1,
		required: true,
	},
	{
		key: "dividerFour",
		inputType: "divider",
		title: "4. 제출자료",
		titleEng: "4. Materials to Submit",
		description: (
			<>
				IR 자료와 소개영상 URL 을 입력해주세요 <br />
			</>
		),
		descriptionEng: <>Please enter the IR data and the URL of the introduction video</>,
	},
	{
		key: "applyCompany.companyData",
		type: "file",
		inputType: "file",
		size: 1,
		title: "[4-1] IR정보",
		titleEng: "[4-1] IR Information",
		required: true,
	},
	{
		key: "applyCompany.descriptionURL",
		type: "text",
		inputType: "text",
		placeholder: "URL을 입력해주세요.",
		placeholderEng: "Please enter URL",
		size: 1,
		title: "[4-2] 소개영상",
		titleEng: "[4-2] Video to Introduce",
		required: false,
	},
];

export const NEX_ANGEL_PARTNERS_FORM_DATA = [
	{
		key: "",
		type: "text",
		inputType: "Q&A",
		title: [
			{
				title: "질문 1. 넥스파트너스 IR 지원방식",
				answer: "IR 지원방식은 넥스파트너스 웹사이트의 APPLY를 통해 Gitbal 플랫폼에서 진행됩니다. 아래 항목을 입력 및 제출해 주세요.\n업로드 파일은 서류(ppt, word, pdf 등), 소개 영상 혹은 드라이브 링크 contact@nexpartners.kr 추가 부탁드립니다.",
			},
			{
				title: "질문 2. 지원 후 절차",
				answer: "서류 접수 확인 메일 및 심사 결과는 기입하신 대표자 이메일을 통해 공유 드릴 예정입니다.\n서류 심사를 통과하신 경우 넥스파트너스 담당자가 개별적인 연락을 통해 미팅을 진행하게 됩니다.",
			},
			{
				title: "질문 3. 지원 분야",
				answer: "바이오, 신소재 및 대체에너시 등의 기술 특화 분야 혹은 기타 다양한 신성장 산업 관련 분야의 신청을 환영합니다.",
			},
			{
				title: "질문 4. 선정 기준",
				answer: "넥스파트너스는 창의적이고 혁신적인 아이디어와 기술을 보유한 업력 3년 이내 스타트업 혹은 예비창업자의 지원을 희망합니다.",
			},
		],
		titleEng: [
			{
				title: "Q1. How To Apply For IR",
				answer: "IR application is available on the Gitbal platform via APPLY on the NEX Angel Partners website.\nPlease enter and submit the items below.\nPlease add a document (ppt, word, pdf and etc.) or an introductory video or drive link : contact@nexpartners.kr",
			},
			{
				title: "Q2. Next Step After Your Application",
				answer: "We will send the confirmation of your application and the results through the email of the representative.\nIf you pass the document screening, the person in charge of the NEX Angel Partners will contact you individually to proceed with the meeting.",
			},
			{
				title: "Q3. Application Field",
				answer: "We welcome applications from deep-technology areas such as bio, new materials and alternative energy sources, or a variety of other new growth industries.",
			},
			{
				title: "Q4. Selection Criteria",
				answer: "We are waiting for startups within three years of establishment or prospective entrepreneurs of having creative and innovative ideas and technologies.",
			},
		],
		required: false,
	},
	{
		key: "dividerFirst",
		inputType: "divider",
		title: "1. 기본정보 입력",
		titleEng: "1. Basic information",
		description: (
			<>
				신청 스타트업의 기본정보를 빠짐없이 알려주시면 적극적으로 검토해 보도록하겠습니다.
				<br />
			</>
		),
		descriptionEng: (
			<>
				Please tell us all the basic information of the application startup. <br />
				We will actively review it.
			</>
		),
	},
	{
		key: "applyCompany.companyName",
		type: "text",
		inputType: "text",
		title: "[1-1] 기업명",
		titleEng: "[1-1] Company Name",
		required: true,
	},
	{
		key: "applyCompany.companyOwner",
		type: "text",
		inputType: "text",
		title: "[1-2] 대표자 이름",
		titleEng: "[1-2] Representative Name",
		required: true,
	},
	{
		key: "applyCompany.contact",
		type: "text",
		inputType: "text",
		title: "[1-3] 대표자 연락처",
		titleEng: "[1-3] Representative Contact",
		required: true,
	},
	{
		key: "email",
		type: "text",
		inputType: "text",
		title: "[1-4] 대표자 이메일",
		titleEng: "[1-4] Representative Email",
		required: true,
	},
	{
		key: "applyCompany.establishmentDate",
		type: "date",
		inputType: "date",
		title: "[1-5] 설립연월",
		titleEng: "[1-5] Date of establishment",
		required: true,
	},
	{
		key: "applyCompany.employees",
		type: "number",
		inputType: "number",
		title: "[1-6] 직원 수",
		titleEng: "[1-6] Number of employees",
		required: true,
	},
	{
		key: "applyCompany.country",
		type: "select",
		inputType: "select",
		title: "[1-7] 국가",
		titleEng: "[1-7] Country",
		size: 1,
		required: true,
	},
	{
		key: "applyCompany.industryCategory",
		type: "checkbox",
		inputType: "checkbox",
		title: "[1-8] 산업분야",
		titleEng: "[1-8] Industrial Field",
		size: 1,
		required: true,
	},
	// {
	//     key: "applyCompany.keyword",
	//     type: "tags",
	//     inputType: "tags",
	//     title: "[1-9] 키워드",
	//     titleEng: "[1-9] Keyword",
	//     size: 1,
	//     required: true
	// },
	{
		key: "dividerSecond",
		inputType: "divider",
		title: "2. 투자정보",
		titleEng: "2. Investment Information",
		description: (
			<>
				신청 스타트업의 기본정보를 빠짐없이 알려주시면 적극적으로 검토해 보도록하겠습니다.
				<br />
			</>
		),
		descriptionEng: (
			<>
				Please tell us all the basic information of the application startup. <br />
				We will actively review it.
			</>
		),
	},
	{
		key: "applyCompany.investStep",
		type: "select",
		inputType: "select",
		size: 1,
		title: "[2-1] 투자단계",
		titleEng: "[2-1] Investment Stage",
		required: false,
	},
	{
		key: "dividerThird",
		inputType: "divider",
		title: "3. 제품/ 기술 / 시장",
		titleEng: "3. Product / Technology / Market",
		description: <>제안하는 제품/서비스에 대한 문제점, 해결방안에 대한 내용을 입력해주세요.</>,
		descriptionEng: (
			<>
				Please enter the contents of the problem and solution for the proposed
				product/service
			</>
		),
	},
	{
		key: "applyCompany.problem",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-1] 문제점",
		titleEng: "[3-1] Problems in the Existing Market",
		required: true,
	},
	{
		key: "applyCompany.solution",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-2] 해결방안",
		titleEng: "[3-2] Solution",
		required: true,
	},
	{
		key: "applyCompany.teamDescription",
		type: "textarea",
		inputType: "textarea",
		textSize: 500,
		size: 1,
		title: "[3-3] 팀 구성 및 소개",
		titleEng: "[3-3] Team Building and Introduction",
		required: true,
	},
	{
		key: "applyCompany.productKeyword",
		type: "tags",
		inputType: "tags",
		title: "[3-4] 제품 키워드",
		titleEng: "[3-4] Product Keyword",
		size: 1,
		required: true,
	},
	{
		key: "dividerFour",
		inputType: "divider",
		title: "4. 제출자료",
		titleEng: "4. Materials to Submit",
		description: (
			<>
				IR 자료와 소개영상 URL 을 입력해주세요 <br />
			</>
		),
		descriptionEng: <>Please enter the IR data and the URL of the introduction video</>,
	},
	{
		key: "applyCompany.companyData",
		type: "file",
		inputType: "file",
		size: 1,
		title: "[4-1] IR정보",
		titleEng: "[4-1] IR Information",
		required: true,
	},
	{
		key: "applyCompany.descriptionURL",
		type: "text",
		inputType: "text",
		placeholder: "URL을 입력해주세요.",
		placeholderEng: "Please enter URL",
		size: 1,
		title: "[4-2] 소개영상",
		titleEng: "[4-2] Video to Introduce",
		required: false,
	},
];

export const INVESTMENT_SCALE = [
	{ "Pre Seed": false, label: "Pre Seed", value: "1" },
	{ Seed: false, label: "Seed", value: "2" },
	{ "Pre Series": false, label: "Pre Series", value: "3" },
	{ "Series A": false, label: "Series A", value: "4" },
	{ "Series B": false, label: "Series B", value: "5" },
	{ "Series C": false, label: "Series C", value: "6" },
	{ "Series D": false, label: "Series D", value: "7" },
	{ "Series E": false, label: "Series E", value: "8" },
	{ "M&A": false, label: "M&A", value: "9" },
	{ "Pre IPO": false, label: "Pre IPO", value: "10" },
	{ IPO: false, label: "IPO", value: "11" },
	// "PreSeed", "Seed", "PreSeries", "SeriesA", "SeriesB", "SeriesC", "SeriesD", "SeriesE",
	// "M&A", "PreIPO", "IPO"
];

export const STATUS_SCALE = [
	{ 심사대기: false, label: i18n.t("constant.ReviewStatusConstant.wait") },
	{ 심사중: false, label: i18n.t("constant.ReviewStatusConstant.review") },
	{ 심사완료: false, label: i18n.t("constant.ReviewStatusConstant.complete") },
];

export const INDUSTRY_CATEGORY_LIST = [
	{ 빅데이터: false, label: i18n.t("constant.ApplyFormConstant.bigData") },
	{ "IT/서비스": false, label: i18n.t("constant.ApplyFormConstant.IT") },
	{ 금융: false, label: i18n.t("constant.ApplyFormConstant.finance") },
	{ 서비스: false, label: i18n.t("constant.ApplyFormConstant.service") },
	{ 인공지능: false, label: i18n.t("constant.ApplyFormConstant.ai") },
	{ 생활: false, label: i18n.t("constant.ApplyFormConstant.life") },
	{ 음식: false, label: i18n.t("constant.ApplyFormConstant.food") },
	{ 쇼핑: false, label: i18n.t("constant.ApplyFormConstant.shopping") },
	{ 유아: false, label: i18n.t("constant.ApplyFormConstant.kid") },
	{ 애완동물: false, label: i18n.t("constant.ApplyFormConstant.pet") },
	{ 스포츠: false, label: i18n.t("constant.ApplyFormConstant.sport") },
	{ 패션: false, label: i18n.t("constant.ApplyFormConstant.fashion") },
	{ 뷰티: false, label: i18n.t("constant.ApplyFormConstant.beauty") },
	{ 게임: false, label: i18n.t("constant.ApplyFormConstant.game") },
	{ 여행: false, label: i18n.t("constant.ApplyFormConstant.travel") },
	{ 교육: false, label: i18n.t("constant.ApplyFormConstant.education") },
	{ 사회: false, label: i18n.t("constant.ApplyFormConstant.society") },
	{ 복지: false, label: i18n.t("constant.ApplyFormConstant.welfare") },
	{ 바이오: false, label: i18n.t("constant.ApplyFormConstant.bio") },
	{ 헬스케어: false, label: i18n.t("constant.ApplyFormConstant.health") },
	{ 기업: false, label: i18n.t("constant.ApplyFormConstant.company") },
	{ 광고: false, label: i18n.t("constant.ApplyFormConstant.ad") },
	{ 마케팅: false, label: i18n.t("constant.ApplyFormConstant.marketing") },
	{ 보안: false, label: i18n.t("constant.ApplyFormConstant.security") },
	{ 엔터테인먼트: false, label: i18n.t("constant.ApplyFormConstant.entertainment") },
	{ 콘텐츠: false, label: i18n.t("constant.ApplyFormConstant.content") },
	{ "VR/AR": false, label: i18n.t("constant.ApplyFormConstant.vrar") },
	{ 환경: false, label: i18n.t("constant.ApplyFormConstant.environment") },
	{ 에너지: false, label: i18n.t("constant.ApplyFormConstant.energy") },
	{ 자동차: false, label: i18n.t("constant.ApplyFormConstant.car") },
	{ 선박: false, label: i18n.t("constant.ApplyFormConstant.ship") },
	{ 부동산: false, label: i18n.t("constant.ApplyFormConstant.house") },
	{ 건설: false, label: i18n.t("constant.ApplyFormConstant.construction") },
	{ 축산업: false, label: i18n.t("constant.ApplyFormConstant.livestock") },
	{ 방송: false, label: i18n.t("constant.ApplyFormConstant.broadcast") },
	{ 통신: false, label: i18n.t("constant.ApplyFormConstant.communication") },
	{ 화학: false, label: i18n.t("constant.ApplyFormConstant.chemical") },
	{ "전기/전자": false, label: i18n.t("constant.ApplyFormConstant.electricity") },
	{ 군수: false, label: i18n.t("constant.ApplyFormConstant.military") },
	{ 모빌리티: false, label: i18n.t("constant.ApplyFormConstant.mobility") },
	{ 공유경제: false, label: i18n.t("constant.ApplyFormConstant.sharingEconomy") },
	{ 수산업: false, label: i18n.t("constant.ApplyFormConstant.fishing") },
	{ 블록체인: false, label: i18n.t("constant.ApplyFormConstant.blockchain") },
	{ 우주: false, label: i18n.t("constant.ApplyFormConstant.space") },
	{ 항공: false, label: i18n.t("constant.ApplyFormConstant.flight") },
	{ 물류: false, label: i18n.t("constant.ApplyFormConstant.logistics") },
	{ 유통: false, label: i18n.t("constant.ApplyFormConstant.distribution") },
	{ 제조: false, label: i18n.t("constant.ApplyFormConstant.manufacture") },
	{ IoT: false, label: i18n.t("constant.ApplyFormConstant.Iot") },
	// "생활", "음식", "쇼핑", "유아", "애완동물", "스포츠", "패션", "뷰티", "게임", "여행", "교육", "사회","서비스","복지", "바이오", "의료",
	// "헬스케어", "기업", "광고", "마케팅", "금융", "보안", "엔터테인먼트", "콘텐츠", "VR/AR", "환경", "에너지", "자동차", "선박",
	// "부동산", "건설", "축산업", "방송", "통신", "화학", "전기/전자", "군수", "모빌리티", "공유경제", "수산업", "블록체인", "우주",
	// "항공", "물류", "유통", "IT/서비스", "제조", "인공지능", "빅데이터", "IoT"
];

export const TRANS_INDUSTRY_CATEGORY_LIST = {
	빅데이터: i18n.t("constant.ApplyFormConstant.bigData"),
	"IT/서비스": i18n.t("constant.ApplyFormConstant.IT"),
	금융: i18n.t("constant.ApplyFormConstant.finance"),
	서비스: i18n.t("constant.ApplyFormConstant.service"),
	인공지능: i18n.t("constant.ApplyFormConstant.ai"),
	생활: i18n.t("constant.ApplyFormConstant.life"),
	음식: i18n.t("constant.ApplyFormConstant.food"),
	쇼핑: i18n.t("constant.ApplyFormConstant.shopping"),
	유아: i18n.t("constant.ApplyFormConstant.kid"),
	애완동물: i18n.t("constant.ApplyFormConstant.pet"),
	스포츠: i18n.t("constant.ApplyFormConstant.sport"),
	패션: i18n.t("constant.ApplyFormConstant.fashion"),
	뷰티: i18n.t("constant.ApplyFormConstant.beauty"),
	게임: i18n.t("constant.ApplyFormConstant.game"),
	여행: i18n.t("constant.ApplyFormConstant.travel"),
	교육: i18n.t("constant.ApplyFormConstant.education"),
	사회: i18n.t("constant.ApplyFormConstant.society"),
	복지: i18n.t("constant.ApplyFormConstant.welfare"),
	바이오: i18n.t("constant.ApplyFormConstant.bio"),
	헬스케어: i18n.t("constant.ApplyFormConstant.health"),
	기업: i18n.t("constant.ApplyFormConstant.company"),
	광고: i18n.t("constant.ApplyFormConstant.ad"),
	마케팅: i18n.t("constant.ApplyFormConstant.marketing"),
	보안: i18n.t("constant.ApplyFormConstant.security"),
	엔터테인먼트: i18n.t("constant.ApplyFormConstant.entertainment"),
	콘텐츠: i18n.t("constant.ApplyFormConstant.content"),
	"VR/AR": i18n.t("constant.ApplyFormConstant.vrar"),
	환경: i18n.t("constant.ApplyFormConstant.environment"),
	에너지: i18n.t("constant.ApplyFormConstant.energy"),
	자동차: i18n.t("constant.ApplyFormConstant.car"),
	선박: i18n.t("constant.ApplyFormConstant.ship"),
	부동산: i18n.t("constant.ApplyFormConstant.house"),
	건설: i18n.t("constant.ApplyFormConstant.construction"),
	축산업: i18n.t("constant.ApplyFormConstant.livestock"),
	방송: i18n.t("constant.ApplyFormConstant.broadcast"),
	통신: i18n.t("constant.ApplyFormConstant.communication"),
	화학: i18n.t("constant.ApplyFormConstant.chemical"),
	"전기/전자": i18n.t("constant.ApplyFormConstant.electricity"),
	군수: i18n.t("constant.ApplyFormConstant.military"),
	모빌리티: i18n.t("constant.ApplyFormConstant.mobility"),
	공유경제: i18n.t("constant.ApplyFormConstant.sharingEconomy"),
	수산업: i18n.t("constant.ApplyFormConstant.fishing"),
	블록체인: i18n.t("constant.ApplyFormConstant.blockchain"),
	우주: i18n.t("constant.ApplyFormConstant.space"),
	항공: i18n.t("constant.ApplyFormConstant.flight"),
	물류: i18n.t("constant.ApplyFormConstant.logistics"),
	유통: i18n.t("constant.ApplyFormConstant.distribution"),
	제조: i18n.t("constant.ApplyFormConstant.manufacture"),
	IoT: i18n.t("constant.ApplyFormConstant.Iot"),
};

export const INDUSTRY_CATEGORY_LIST_ENG = [
	"Bigdata",
	"ITService",
	"Finance",
	"Service",
	"Ai",
	"Life",
	"Food",
	"Shopping",
	"Child",
	"Pet",
	"Sports",
	"Fashion",
	"Beauty",
	"Game",
	"Travel",
	"Education",
	"Society",
	"Welfare",
	"Bio",
	"Medical",
	"HealthCare",
	"Enterprise",
	"Advertising",
	"Marketing",
	"Security",
	"Entertainment",
	"Contents",
	"VRAR",
	"Environment",
	"Energy",
	"Automobile",
	"Ship",
	"RealEstate",
	"Construction",
	"LivestockIndustry",
	"Broadcasting",
	"Communication",
	"Chemistry",
	"Electronic",
	"Munitions",
	"Mobility",
	"SharedEconomy",
	"FisheriesIndustry",
	"BlockChain",
	"Space",
	"Flight",
	"Logistics",
	"Distribution",
	"Manufacturing",
	"IoT",
];

export const INVEST_STEP = [
	"PreSeed",
	"Seed",
	"PreSeries",
	"SeriesA",
	"SeriesB",
	"SeriesC",
	"SeriesD",
	"SeriesE",
	"M&A",
	"PreIPO",
	"IPO",
];

export const COUNTRY = [
	"가나",
	"가봉",
	"가이아나",
	"감비아",
	"프랑스(과데루프섬)",
	"과테말라",
	"미국(괌)",
	"그레나다",
	"그루지야",
	"그리스",
	"덴마크(그린란드)",
	"기니비소",
	"기니",
	"나미비아",
	"나이지리아",
	"남아프리카공화국",
	"네덜란드(네델란드)",
	"네덜란드(네덜란드령앤틸리스)",
	"네팔",
	"노르웨이",
	"오스트레일리아(노퍽섬)",
	"뉴질랜드",
	"프랑스(뉴칼레도니아섬)",
	"니제르",
	"니카라과",
	"타이완(대만)",
	"덴마크",
	"도미니카연방",
	"도미니카공화국",
	"독일",
	"라오스'",
	"라트비아",
	"러시아",
	"레바논",
	"레소토",
	"루마니아",
	"르완다",
	"룩셈부르크",
	"라이베리아",
	"리비아",
	"프랑스(레위니옹섬)",
	"리투아니아",
	"리첸쉬테인",
	"마다가스카르",
	"미국(마아샬제도)",
	"미크로네시아(마이크로네시아)",
	"마케도니아",
	"말라위",
	"말레이지아",
	"말리",
	"몰타",
	"프랑스(마르티니크섬)",
	"멕시코",
	"모나코",
	"모로코",
	"모리셔스",
	"모리타니",
	"모잠비크",
	"영국(몽세라)",
	"몰도바",
	"",
	"몰디브",
	"몽고",
	"미국",
	"미국(버진제도)",
	"미국(사모아제도)",
	"미얀마",
	"바누아투",
	"바레인",
	"바베이도스",
	"바하마",
	"방글라데시",
	"벨라루스",
	"영국(버뮤다섬)",
	"베네수엘라",
	"베넹",
	"베트남",
	"벨기에",
	"벨리세",
	"보스니아헤르체코비나",
	"보츠와나",
	"볼리비아",
	"부르키나파소",
	"부탄",
	"미국(사이판)",
	"불가리아",
	"브라질",
	"브루네이(나이)",
	"브룬디",
	"미국(사모아)",
	"구서사모아",
	"사우디아라비아",
	"사이프러스",
	"산마리노",
	"세네갈",
	"세이셸",
	"세인트루시아",
	"세인트빈센트그레나딘",
	"세인트키츠네비스",
	"솔로몬아일란드",
	"수리남",
	"스리랑카",
	"스와질랜드",
	"스웨덴",
	"스위스",
	"스페인(에스파니아)",
	"슬로바키아",
	"슬로베니아",
	"시에라리온",
	"싱가포르",
	"아랍에미레이트연합국",
	"네덜란드(아루바섬)",
	"아르메니아",
	"아르헨티나",
	"아이슬란드",
	"아이티",
	"아일란드(에이레)",
	"아제르바이잔",
	"아프가니스탄",
	"영국(안귈라섬)",
	"안도라",
	"앤티과바부다",
	"알바니아",
	"알제리",
	"앙골라",
	"에리트리아",
	"에스토니아",
	"에콰도르",
	"엘살바도르",
	"영국",
	"영국(버진제도)",
	"예멘",
	"오만",
	"오스트레일리아(호주)",
	"오스트리아",
	"온두라스",
	"요르단",
	"우간다",
	"우루과이",
	"우즈베크",
	"우크라이나",
	"이디오피아",
	"이라크",
	"이란",
	"이스라엘",
	"이집트",
	"이탈리아(이태리)",
	"인도",
	"인도네시아",
	"일본",
	"자메이카",
	"잠비아",
	"중국",
	"중국(마카오)",
	"중국(홍콩)",
	"중앙아프리카",
	"지부티",
	"영국(지브롤터)",
	"짐바브웨",
	"차드",
	"체코",
	"체코슬로바키아",
	"칠레",
	"카나다",
	"카메룬",
	"카보베르데",
	"영국(케이만제도)",
	"카자흐",
	"카타르",
	"캄보디아",
	"케냐",
	"코스타리카",
	"코트디봐르",
	"콜롬비아",
	"콩고",
	"쿠바",
	"쿠웨이트",
	"크로아티아",
	"키르키즈스탄",
	"키리바티",
	"타지키스탄",
	"탄자니아",
	"타이(태국)",
	"영국(터크스케이코스제도)",
	"터키",
	"토고",
	"통가",
	"투발루",
	"튀니지",
	"트리니다드토바고",
	"파나마",
	"파라과이",
	"파키스탄",
	"파푸아뉴기니",
	"미국(팔라우섬)",
	"덴마크(페로즈제도)",
	"페루",
	"포르투갈",
	"폴란드",
	"미국(푸에르토리코섬)",
	"프랑스",
	"프랑스(기아나)",
	"프랑스(폴리네시아)",
	"피지",
	"필란드",
	"필리핀",
	"한국",
	"헝가리",
];

export const COUNTRY_ENG = [
	"GHANA",
	"GABON",
	"GUYANA",
	"GAMBIA",
	"GUADELOUPE",
	"GUATEMALA",
	"GUAM",
	"GRENADA",
	"GEORGIA",
	"GREECE",
	"GREENLAND",
	"GUINEABISSAU",
	"GUINEA",
	"NAMIBIA",
	"NIGERIA",
	"SOUTHAFRICA",
	"NETHERLANDS",
	"NETHERLANDSANTILLES",
	"NEPAL",
	"NORWAY",
	"NORFOLKISLAND",
	"NEWZEALAND",
	"NEWCALEDONIA",
	"NIGER",
	"NICARAGUA",
	"TAIWAN",
	"DENMARK",
	"DOMINICA",
	"DOMINICANREPUBLIC",
	"GERMANY",
	"LAOPEOPLESDEMREP",
	"LATVIA",
	"RUSSIANFEDERATION",
	"LEBANON",
	"LESOTHO",
	"ROMANIA",
	"RWANDA",
	"LUXEMBOURE",
	"LIBERIA",
	"LIBYANARABJAMAHIRIYA",
	"REUNION",
	"LITHUANIA",
	"LIECHTENSTEIN",
	"MADAGASCAR",
	"MARSHALLISLANDS",
	"MICRONESIA",
	"MACEDONIA",
	"MALAWI",
	"MALAYSIA",
	"MALI",
	"MALTA",
	"MARTINIQUE",
	"MEXICO",
	"MONACO",
	"MOROCCO",
	"MAURITIUS",
	"MAURITANIA",
	"MOZAMBIQUE",
	"MONTSERRAT",
	"MOLDOVA",
	"REPUBLICOF",
	"MALDIVES",
	"MONGOLIA",
	"USA",
	"VIRGINISLANDSUS",
	"AMERICANSAMOA",
	"MYANMAR",
	"VANUATU",
	"BAHRAIN",
	"BARBADOS",
	"BAHAMAS",
	"BANGLADESH",
	"BELARUS",
	"BERMUDA",
	"VENEZUELA",
	"BENIN",
	"VIETNAM",
	"BELGIUM",
	"BELIZE",
	"BosniaandHerzegovina",
	"BOTSWANA",
	"BOLIVIA",
	"BURKINAFASO",
	"BHUTAN",
	"NORTHERNMARIANAISLANDS",
	"BULGARIAREP",
	"BRAZIL",
	"BRUNEIDARUSSALAM",
	"BURUNDI",
	"",
	"SAMOA",
	"SAUDIARABIA",
	"CYPRUS",
	"SANMARINO",
	"SENEGAL",
	"SEYCHELLES",
	"SAINTLUCIA",
	"SAINTVINCENTANDTHEGRENADINES",
	"SAINTKITTSANDNEVIS",
	"SOLOMONISLANDS",
	"SURINAME",
	"SRILANKA",
	"SWAZILAND",
	"SWEDEN",
	"SWITZERLAND",
	"SPAIN",
	"SLOVAKIA",
	"SLOVENIA",
	"SIERRALEONE",
	"SINGAPORE",
	"UNITEDARABEMIRATES",
	"ARUBA",
	"ARMENIA",
	"ARGENTINA",
	"ICELAND",
	"HAITI",
	"IRELAND",
	"AZERBAIJAN",
	"AFGHANISTAN",
	"ANGUILLA",
	"ANDORRA",
	"ANTIGUAANDBARBUDA",
	"ALBANIA",
	"ALGERIA",
	"ANGOLA",
	"ERITREA",
	"ESTONIA",
	"ECUADOR",
	"ELSALVADOR",
	"UNITEDKINGDOM",
	"VIRGINISLANDSBRITISH",
	"YEMEN",
	"OMAN",
	"AUSTRALIA",
	"AUSTRIA",
	"HONDURAS",
	"JORDAN",
	"UGANDA",
	"URUGUAY",
	"UZBEKISTAN",
	"UKRAINE",
	"ETHIOPIA",
	"IRAQ",
	"IRANISLAMICREP",
	"ISRAEL",
	"EGYPT",
	"ITALY",
	"INDIA",
	"INDONESIA",
	"JAPAN",
	"JAMAICA",
	"ZAMBIA",
	"CHINAPEOPLESREP",
	"MACAO",
	"CHINAHONGKONG",
	"CENTRALAFRICANREPUBLIC",
	"DJIBOUTI",
	"GIBRALTAR",
	"ZIMBABWE",
	"CHAD",
	"CZECHREP",
	"CZECHOSLOVAKIA",
	"CHILE",
	"CANADA",
	"CAMEROON",
	"CAPEVERDE",
	"CAYMANISLANDS",
	"KAZAKHSTAN",
	"QATAR",
	"CAMBODIA",
	"KENYA",
	"COSTARICA",
	"COTEDIVOIRE",
	"COLOMBIA",
	"CONGO",
	"CUBA",
	"KUWAIT",
	"CROATIA",
	"KYRGYZSTAN",
	"KIRIBATI",
	"TAJIKISTAN",
	"TANZANIAUNITEDREP",
	"THAILAND",
	"TURKSANDCAICOSISLANDS",
	"TURKEY",
	"TOGO",
	"TONGA",
	"TUVALU",
	"TUNISIA",
	"TRINIDADANDTOBAGO",
	"PANAMAREP",
	"PARAGUAY",
	"PAKISTAN",
	"PAPUANEWGUINEA",
	"PALAU",
	"FAROEISLANDS",
	"PERU",
	"PORTUGAL",
	"POLANDREP",
	"PUERTORICO",
	"FRANCE",
	"FRENCHGUIANA",
	"FRENCHPOLYNESIA",
	"FIJI",
	"FINLAND",
	"PHILIPPINES",
	"KOREA",
	"HUNGARYREP",
];
